import React, { useState, useRef } from "react";
import { gsap } from "gsap";
import { Link, useNavigate } from "react-router-dom"; // For navigation
import "./Navbar.css"; // Your CSS file

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [hoverImage, setHoverImage] = useState(
    "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1747497752/SIDE%20BANNER/g2ucrp9bktlwo06bzwxj.png" // Default image
  );
  const menuRef = useRef(null);
  const navigate = useNavigate();

  const navItems = [
    { name: "HOME", path: "/", bgImage: "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1747497752/SIDE%20BANNER/g2ucrp9bktlwo06bzwxj.png" },
    { name: "SERVICES", path: "/service", bgImage: "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1747497752/SIDE%20BANNER/mfrdll4h7amjjcykcrx2.png" },
    { name: "CLIENTS", path: "/cleints", bgImage: "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1747497754/SIDE%20BANNER/bxpfxe47ppi2oiboh0ks.png" },
    { name: "CONTACT", path: "/contact", bgImage: "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1747497752/SIDE%20BANNER/nzscuqw8bgo45jrvgqa6.png" },
    { name: "BLOG", path: "/blog", bgImage: "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1747497751/SIDE%20BANNER/ljvm1hm2vatvq5bo5lsk.png" },


  ];

  // Combined function to close menu and optionally navigate
  const closeMenuAndNavigate = (path) => {
    if (!menuRef.current) return; // Guard clause

    const tl = gsap.timeline({
      defaults: { ease: "power3.inOut" },
      onComplete: () => {
        setIsOpen(false); // Update state after animation
        if (path) {
          navigate(path); // Navigate if a path is provided
        }
      },
    });

    // Your existing closing animation sequence
    tl.to(".menu-items li", { y: -20, opacity: 0, stagger: 0.1, duration: 0.4 })
      .to(".menu-image", { y: "100%", opacity: 0, duration: 0.6 }, "-=0.3")
      .to(".white-layer", { scaleX: 0, transformOrigin: "right", duration: 0.6 }, "-=0.2")
      .to(".black-layer", { scaleX: 0, transformOrigin: "right", duration: 0.6 }, "-=0.4")
      .to(menuRef.current, { opacity: 0, duration: 0.3 }, "-=0.2")
      .set(menuRef.current, { display: "none" });
  };

  const toggleMenu = () => {
    if (!menuRef.current) return; // Guard clause

    if (!isOpen) {
      setIsOpen(true); // Set state *before* animation for button visibility
      const tl = gsap.timeline({ defaults: { ease: "power3.inOut" } });

      // Your existing opening animation sequence
      tl.set(menuRef.current, { display: "flex", opacity: 0 }) // Set display, then animate opacity
        .to(menuRef.current, { opacity: 1, duration: 0.01 }) // Make it opaque almost instantly
        .fromTo(".black-layer", { scaleX: 0, transformOrigin: "left" }, { scaleX: 1, duration: 0.6 })
        .fromTo(".white-layer", { scaleX: 0, transformOrigin: "left" }, { scaleX: 1, duration: 0.8 }, "-=0.4")
        .fromTo(".menu-items li", { y: -20, opacity: 0 }, { y: 0, opacity: 1, stagger: 0.1, duration: 0.6 }, "-=0.2")
        .fromTo(".menu-image", { y: "100%", opacity: 0 }, { y: "0%", opacity: 1, duration: 0.8 }, "-=0.5");
    } else {
      closeMenuAndNavigate(null); // Call the combined function without a path to just close
    }
  };

  return (
    <div className="navbar">
      <div className="logo">
       <Link to='/'> <img 
          src="https://res.cloudinary.com/ddkyeuhk8/image/upload/v1745487285/Digisavvy/ij0wyy1cdhpyo92rzwhn.png" 
          alt="Digisavvy Logo"
        /></Link>
      </div>

      <div className="controls">
        {/* Apply your .hidden and .visible classes based on isOpen state */}
        <div
          className={`toggle-btn ${isOpen ? "hidden" : ""}`}
          onClick={toggleMenu}
          role="button"
          aria-label="Open menu"
          tabIndex={0} // Make it focusable
          onKeyDown={(e) => e.key === 'Enter' && toggleMenu()} // Keyboard accessibility
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div
          className={`close-btn ${isOpen ? "visible" : ""}`}
          onClick={toggleMenu}
          role="button"
          aria-label="Close menu"
          tabIndex={0} // Make it focusable
          onKeyDown={(e) => e.key === 'Enter' && toggleMenu()} // Keyboard accessibility
        >
          ✕ {/* HTML entity for X */}
        </div>
      </div>

      {/* menuRef.current initially has display: "none" via inline style, GSAP will handle it */}
      <div className="menu" ref={menuRef} style={{ display: "none" }}>
        <div className="black-layer"></div>
        <div className="white-layer"></div>
        <div className="menu-content">
          <ul className="menu-items">
            {navItems.map((item) => ( // Removed index as key when item.name or item.path is unique
              <li
                key={item.name} // Assuming names are unique, otherwise use item.path or index
                onMouseEnter={() => setHoverImage(item.bgImage)}
                onClick={() => closeMenuAndNavigate(item.path)}
                role="menuitem"
                tabIndex={0} // Make it focusable
                onKeyDown={(e) => e.key === 'Enter' && closeMenuAndNavigate(item.path)} // Keyboard accessibility
              >
                {item.name}
              </li>
            ))}
          </ul>
          <div
            className="menu-image"
            style={{ backgroundImage: `url(${hoverImage})` }}
            role="img" // Accessibility
            aria-label="Decorative background image for hovered menu item" // Accessibility
          ></div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;